import 'ol/ol.css';
import Map from 'ol/Map';
import View from 'ol/View';
import { Draw, Modify, Snap } from 'ol/interaction';
import { createBox } from 'ol/interaction/Draw';
import { Tile as TileLayer, Vector as VectorLayer } from 'ol/layer';
import VectorSource from 'ol/source/Vector';
import { Circle as CircleStyle, Fill, Stroke, Style } from 'ol/style';
let mapStore = {};

let source = new VectorSource();
/**
 * openlayer的交互合集
 */
mapStore.Interactions = {};
mapStore.drawSource = source;

mapStore.drawVector = new VectorLayer({
    source: source,

    style: new Style({
        fill: new Fill({
            color: 'rgba(255, 255, 255, 0.2)'
        }),
        stroke: new Stroke({
            color: '#ffcc33',
            width: 2
        }),
        image: new CircleStyle({
            radius: 7,
            fill: new Fill({
                color: '#ffcc33'
            })
        })
    }),
    zIndex: 999,
});

let draw = new Draw({
    source: source,
    type: 'Polygon'
});

// var modify = new Modify({ source: source });
//绘制面
mapStore.Interactions.drawPolygon = draw;


//创建一个交互式绘图对象
let lineDraw = new Draw({
    //绘制的数据源
    source: source,
    //绘制类型
    type: 'LineString',
    //样式
    style: new Style({
        fill: new Fill({
            color: 'rgba(255,255,255,0.2)'
        }),
        stroke: new Stroke({
            color: 'rgba(0,0,0,0.5)',
            lineDash: [10, 10],
            width: 2
        }),
        image: new CircleStyle({
            radius: 5,
            stroke: new Stroke({
                color: 'rgba(0,0,0,0.7)'
            }),
            fill: new Fill({
                color: 'rgba(255,255,255,0.2)'
            })
        })
    })
});

//绘制线
mapStore.Interactions.drawLine = lineDraw;


let drawRect = new Draw({
    source: source,
    type: 'Circle',
    geometryFunction: createBox()
});

//绘制线
mapStore.Interactions.drawRect = drawRect;

//绘制圆
let drawCircle = new Draw({
    source: source,
    type: 'Circle',
});
mapStore.Interactions.drawCircle = drawCircle;
export default mapStore;


// WEBPACK FOOTER //
// ./src/store/mapStore.js